/**
 * http汎用ツール関数
 */
import axios from 'mdoc/admin/axios/axiosService';

/**
 * 公用get请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const get = (url, data, headers, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.get(url, {
            params: data
        }).then(res => resolve(res.data)).catch(err => {
            // window.location = '/admin.html#/404';
        })
    })

/**
 * 公用post请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const post = (url, data, headers, async = true, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.post(url,data,{}
        ).then(res => resolve(res.data)).catch(err => {
            // window.location = '/admin.html#/404';
        })
    })

/**
 * 公用delete请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const del = (url, data, headers, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.delete(url,{
            params:data}
        ).then(res => resolve(res.data)).catch(err => {
            // window.location = '/admin.html#/404';
        })
    })

/**
 * 公用put请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const put = (url, data, headers, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.put(url,data,{}
        ).then(res => resolve(res.data)).catch(err => {
            // window.location = '/admin.html#/404';
        })
    })

/**
 * 公用upload请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const upload = (url, data, headers, async = true, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.post(url,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }}
        ).then(res => resolve(res.data)).catch(err => {
            msg = err;
            reject(msg);
            // window.location = '/admin.html#/404';
        })
    })

/**
 * 公用downloadImg请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const downloadImg = (url, data, headers, async = true, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.get(url, {
            params: data,
            responseType: "arraybuffer",
            headers: {
                'Content-Type': 'multipart/form-data;charset=UTF-8'
            }
        }).then(res => resolve(res.data)).catch(err => {
            // window.location = '/admin.html#/404';
        })
    })
/**
 * 公用download template请求
 * @param url       接口地址
 * @param data      接口参数
 * @param headers   接口所需header配置
 * @param msg       API ERROR提示
 */
export const downloadTemplate = (url, data, headers, async = true, msg = 'API ERROR') =>
    new Promise((resolve, reject) => {
        axios.get(url, {
            params: data,
            responseType: "arraybuffer",
            headers: {
                'Content-Type': 'multipart/form-data;charset=UTF-8'
            }
        }).then(res => resolve(res.data)).catch(err => {
            // window.location = '/admin.html#/404';
        })
    })